import React from "react";
import { Box, Grid } from "@mui/material";
import { useNavigate } from "react-router";
import { HeaderMegaMenuSX } from "../../../headerMegaMenu";
import { StyledPaper } from "@hcl-commerce-store-sdk/react-component";
import { StyledMenuTitle, StyledMenuSubtitle, StyledMenuHeading, StyledMenuLink } from "../../style";
import { RedCard } from "../DesktopActionCards";
import { PRISEDERDV } from "../../../../../constants/routes";

interface DesktopOutilsMenuProps {
  closeHeaderMenu?: () => any;
  menuLinksData: Record<string, any>;
}

const DesktopOutilsMenu: React.FC<DesktopOutilsMenuProps> = ({ closeHeaderMenu, menuLinksData }) => {
  const navigate = useNavigate();

  const OutilsData = menuLinksData?.outils;
  const univers = OutilsData?.Univers || [];

  if (!OutilsData) return null;

  return (
    <StyledPaper className="megamenu-wrapper expanded-menu-mega-menu-v2" sx={HeaderMegaMenuSX.wrapper}>
      <Box>
        <StyledMenuTitle sx={{ mb: 1 }}>{OutilsData.label}</StyledMenuTitle>
        <StyledMenuSubtitle sx={{ mb: 1 }}>{OutilsData.description}</StyledMenuSubtitle>

        {/* Columns — responsive: 1 column on xs, 2 on sm, 3-4 on md+ depending on items */}
        <Grid
          container
          spacing={4}
          sx={{
            mt: 2,
            flexWrap: "nowrap", // 🚀 prevents row break
          }}>
          {univers.map((u: any, idx: number) => (
            <Grid item key={idx} xs={12} sm={6} md={2.4}>
              <StyledMenuHeading sx={{ mb: 1, color: "#252427" }}>{u.name}</StyledMenuHeading>

              <Box sx={{ display: "flex", flexDirection: "column", mt: 1 }}>
                {(u.configurateurs || []).map((c: any, i: number) => {
                  // Each c has: title and link: { url, type }
                  const url = c?.link?.url;
                  const type = (c?.link?.type || "internal").toLowerCase();
                  // if JSON has iconSrc inside each configurateur, you can use getIcon(c.iconSrc)
                  return (
                    <StyledMenuLink
                      sx={{ fontWeight: 500 }}
                      key={i}
                      onClick={(e: React.MouseEvent) => {
                        e.preventDefault();
                        if (!url) return;
                        if (type === "external") {
                          // open in a new tab
                          window.open(url, "_blank", "noopener,noreferrer");
                        } else {
                          // internal navigation — support relative and absolute routes
                          closeHeaderMenu && closeHeaderMenu();
                          navigate(url);
                        }
                      }}
                      role="link">
                      {/* optional icon: uncomment if your configurateur has iconSrc */}
                      {/* {c.iconSrc ? getIcon(c.iconSrc, c.title) : null} */}
                      <span style={{ marginLeft: 0 }}>{c.title}</span>
                    </StyledMenuLink>
                  );
                })}
              </Box>
            </Grid>
          ))}
          <Grid
            item
            xs={12}
            sm={6}
            md="auto"
            sx={{
              display: "flex",
              alignItems: "stretch",
              flexBasis: { md: "352px" }, // fixed width on desktop
              maxWidth: { md: "352px" },
              flexGrow: 0,
              mt: { xs: 3, lg: -12 },
              mr: 10,
            }}>
            <Box
              sx={{
                width: "5px",
                backgroundColor: "#EFEFEF",
                marginRight: "12px",
              }}
            />
            <RedCard
              closeHeaderMenu={closeHeaderMenu}
              title="BESOIN DE CONSEIL"
              desc="Nos équipes sont là pour vous conseiller à chaque étape de votre projet. Prenez rendez-vous avec un
                  expert."
              btnLabel="PRENDRE RENDEZ-VOUS"
              ctaLink={PRISEDERDV}
            />
          </Grid>
        </Grid>
      </Box>
    </StyledPaper>
  );
};

export default DesktopOutilsMenu;
